import {
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Dialog as MuiDialog,
} from '@mui/material';
import { JSX } from 'react';

interface ExDialogProps extends DialogProps {
  titleContent: JSX.Element;
  bodyContent: JSX.Element;
  actions: JSX.Element;
  dividers: boolean;
}

const Dialog = ({
  open,
  onClose,
  titleContent,
  bodyContent,
  actions,
  dividers = false,
  ...rest
}: ExDialogProps) => {
  return (
    <MuiDialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          width: '100%',
          margin: { xs: '16px', sm: '22px', md: '26px', lg: '32px' },
        },
      }}
      {...rest}
    >
      <DialogTitle>{titleContent}</DialogTitle>
      <DialogContent dividers={dividers}>{bodyContent}</DialogContent>
      <DialogActions>{actions}</DialogActions>
    </MuiDialog>
  );
};

export default Dialog;
